function prepareWordSet(wordset) {
  return wordset;
}

const wordset = (words) => prepareWordSet(`${words}`);
export default wordset;
